angular.module("inoApp.templates",
    [
        "templates/core/layout/shell.html",
        "templates/core/layout/header.html",
        "templates/core/layout/header_search.html",
        "templates/core/layout/ribbon.html",
        "templates/core/layout/navMenu.html",
        "templates/core/layout/tabstrip.html",
        "templates/core/layout/footer.html",
        "templates/core/layout/loadingIndicator.html",
        "templates/core/layout/authNotAuthorizedDialog.html",
        "templates/core/layout/authNotAuthenticatedDialog.html",
        "templates/core/layout/widgetControl.html",
        "templates/core/layout/widgetDataTable.html"
    ]);

angular.module("templates/core/layout/shell.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/shell.html",
        "<div>\n" +
        "    <div layout-header></div>\n" +
        "    <loading-indicator busy-config=\"shellVm.busyIndicatorConfig\"></loading-indicator>\n" +
        "    <aside id=\"left-panel\" layout-nav-menu></aside>\n" +
        "    <div id=\"main\" role=\"main\">\n" +
        "        <div id=\"ribbon\" layout-ribbon data-ribbon=\"\"></div>\n" +
        "        <div id=\"content\" ui-view class=\"view-animate\"></div>\n" +
        "        <div auth-not-authorized-dialog></div>\n" +
        "    </div>\n" +
        "    <div class=\"page-footer\"><span layout-footer></span></div>\n" +
        "    <div auth-not-authenticated-dialog></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("templates/core/layout/header.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/header.html",
        "<header id=\"header\">\n" +
        "    <div id=\"logo-group\">\n" +
        "        <span class=\"logo hidden-xs\"></span>\n" +
        "        <span class=\"logo-secondary visible-xs-block\"></span>\n" +
        "    </div>\n" +
        "    <div class=\"pull-right\">\n" +
        "        <ul class=\"header-dropdown-list hidden-xs ng-cloak\">\n" +
        "            <layout-header-search></layout-header-search>\n" +
        "            <li dropdown ng-show=\"headerVm.userIsAuthenticated\">\n" +
        "                <a href=\"\" dropdown-toggle>\n" +
        "                    <span ng-bind-html=\"headerVm.userProfile.firstName\"></span>\n" +
        "                    <span ng-bind-html=\"headerVm.userProfile.lastName\"></span>\n" +
        "                    <i class=\"fa fa-angle-down\"></i>\n" +
        "                </a>\n" +
        "                <ul class=\"dropdown-menu pull-right\">\n" +
        "                    <li class=\"\">\n" +
        "                        <a ng-href=\"{{headerVm.editProfileUrl}}\" data-translate=\"menubar.editProfile\"></a>\n" +
        "                    </li>\n" +
        "                    <li class=\"divider\"></li>\n" +
        "                    <li class=\"\">\n" +
        "                        <a ng-href=\"{{headerVm.signOutUrl}}\"><i class=\"fa fa-sign-out\"></i> {{'menubar.signOut' | translate}}</a>\n" +
        "                    </li>\n" +
        "                </ul>\n" +
        "            </li>\n" +
        "            <li style=\"min-width:35px; margin-left:20px; margin-top: 16px;\">\n" +
        "                <a href=\"\" ng-show=\"headerVm.isCurrent('fr')\" ng-click=\"headerVm.changeLanguage('en')\">EN</a>\n" +
        "                <a href=\"\" ng-show=\"headerVm.isCurrent('en')\" ng-click=\"headerVm.changeLanguage('fr')\">FR</a>\n" +
        "            </li>\n" +
        "        </ul>\n" +
        "    </div>\n" +
        "</header>\n" +
        "");
}]);

angular.module("templates/core/layout/header_search.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/header_search.html",
        "<li ng-if=\"false\">\n" +
        "</li>\n" +
        "");
}]);

angular.module("templates/core/layout/ribbon.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/ribbon.html",
        "<span class=\"ribbon-button-alignment\">\n" +
        "    <span id=\"\" class=\"btn btn-ribbon\" toggle-menu data-title=\"Collapse Menu\" rel=\"tooltip\" data-placement=\"bottom\"><i class=\"fa fa-reorder\"></i></span>\n" +
        "</span>\n" +
        "<state-breadcrumbs>\n" +
        "    <!-- This is auto generated -->\n" +
        "</state-breadcrumbs>\n" +
        "");
}]);

angular.module("templates/core/layout/navMenu.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/navMenu.html",
        "<div>\n" +
        "    <div class=\"app-info\">\n" +
        "    {{ 'config.appName' | translate }}\n" +
        "    </div>\n" +
        "    <nav>\n" +
        "        <ul smart-menu>\n" +
        "            <li data-ui-sref-active=\"active\" ng-repeat-start=\"menuInfo in navMenuVm.menuInfos\" ng-if=\"!menuInfo.subMenuInfos\">\n" +
        "                <a data-ui-sref=\"{{ menuInfo.stateName }}\" title=\"{{ menuInfo.resourceKey | translate }}\">\n" +
        "                    <i class=\"fa fa-lg fa-fw {{menuInfo.iconClass}}\"></i> <span class=\"menu-item-parent\">{{ menuInfo.resourceKey | translate }}</span>\n" +
        "                </a>\n" +
        "            </li>\n" +
        "            <li data-menu-collapse ng-if=\"menuInfo.subMenuInfos != null\" ng-repeat-end>\n" +
        "                <a href=\"#\"><i class=\"fa fa-lg fa-fw {{menuInfo.iconClass}}\"></i> <span class=\"menu-item-parent\">{{ menuInfo.resourceKey | translate }}</span></a>\n" +
        "                <ul>\n" +
        "                    <li data-ui-sref-active=\"active\" ng-repeat=\"subMenuInfo in menuInfo.subMenuInfos\">\n" +
        "                        <a data-ui-sref=\"{{ subMenuInfo.stateName }}\">\n" +
        "                            {{ subMenuInfo.resourceKey | translate }}\n" +
        "                        </a>\n" +
        "                    </li>\n" +
        "                </ul>\n" +
        "            </li>\n" +
        "        </ul>\n" +
        "    </nav>\n" +
        "    <span class=\"minifyme\" minify-menu> <i class=\"fa fa-arrow-circle-left hit\"></i> </span>\n" +
        "</div>\n" +
        "");
}]);

angular.module("templates/core/layout/footer.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/footer.html",
        "<div class=\"row\">\n" +
        "   <div class=\"col-xs-12 col-sm-6\">\n" +
        "       <span class=\"txt-color-white\">Inovestor</span>\n" +
        "   </div>\n" +
        "   <div class=\"col-xs-6 col-sm-6 text-right hidden-xs\">\n" +
        "   </div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("templates/core/layout/authNotAuthenticatedDialog.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/authNotAuthenticatedDialog.html",
        "<div id=\"authentication-dialog\" class=\"modal fade \">" +
        "    <div class=\"modal-dialog\">" +
        "        <div class=\"modal-header modal-header-special\">" +
        "            <div class=\"logo\"></div>" +
        "        </div>" +
        "        <div class=\"modal-content\">" +
        "            <div class=\"modal-body\">" +
        "                <h1>" +
        "                    <i class=\"fa fa-lock text-muted fa-border fa-3x pull-left\"></i><span class=\"modal-title\" data-translate=\"templates.authenticationDialog.title\"></span>" +
        "                </h1>" +
        "                <h1>" +
        "                    <i class=\"user-icon fa fa-user online fa-4x text-muted air air-top-right hidden-xs\"></i>" +
        "                    <span ng-bind-html=\"vm.userProfile.firstName\"></span>" +
        "                    <span ng-bind-html=\"vm.userProfile.lastName\"></span>" +
        "                </h1>" +
        "                <p class=\"no-margin\" data-translate=\"templates.authenticationDialog.content\"></p>" +
        "                <br/>" +
        "                <p class=\"no-margin margin-top-10\">" +
        "                    <a ng-href=\"{{vm.timeoutSignInUrl}}\" class=\"btn btn-primary\" data-translate=\"templates.authenticationDialog.actionText\"></a>" +
        "                </p>" +
        "            </div>" +
        "        </div>" +
        "    </div>" +
        "</div>" +
        "");
}]);

angular.module("templates/core/layout/authNotAuthorizedDialog.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/authNotAuthorizedDialog.html",
        "<div id=\"authorization-dialog\" class=\"modal fade\">" +
        "    <div class=\"modal-dialog\">" +
        "        <div class=\"modal-content\">" +
        "            <div class=\"modal-header\">" +
        "                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">" +
        "                    ×" +
        "                </button>" +
        "                <i class=\"fa fa-ban fa-2x text-danger pull-left\"></i><h4 class=\"modal-title\" data-translate=\"templates.authorizationDialog.title\"></h4>" +
        "            </div>" +
        "            <div class=\"modal-body\">" +
        "                <span data-translate=\"templates.authorizationDialog.content\"></span>" +
        "            </div>" +
        "        </div>" +
        "    </div>" +
        "</div>" +
        "");
}]);

angular.module("templates/core/layout/loadingIndicator.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/loadingIndicator.html",
        "<div class=\"loading-indicator\">" +
        "    <div></div>" +
        "    <i class=\"fa fa-circle-o-notch fa-spin\"></i>" +
        "    <div style=\"color: #E0E0E0; margin-top: 10px;\">" +
        "        <p>{{ busyConfig.textResourceKey | translate }}</p>" +
        "    </div>" +
        "</div>" +
        "");
}]);

angular.module("templates/core/layout/tabstrip.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/tabstrip.html",
        "<div class=\"tabs-left\">" +
        "    <ul class=\"nav nav-tabs tabs-left\">" +
        "        <li ng-repeat=\"tab in vm.tabs\" ng-class=\"{ 'hide-tabstrip' : tab.isHidden }\">" +
        "            <a class=\"tabheader id-{{tab.tabId}}\" href=\"#{{tab.tabId}}\" data-toggle=\"tab\"></a>" +
        "        </li>" +
        "    </ul>" +
        "    <div class=\"tab-content\">" +
        "        <div class=\"tab-pane\" ng-repeat=\"tab in vm.tabs\" id=\"{{tab.tabId}}\" ng-class=\"{ 'hide-tabstrip' : tab.isHidden }\">" +
        "        </div>" +
        "    </div>" +
        "    <div ng-transclude></div>" +
        "</div>" +
        "");
}]);


angular.module("templates/core/layout/widgetControl.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/widgetControl.html",
        "<section class=\"widget-control\" id=\"{{widgetId}}\">" +
        "	<div class=\"row\">" +
        "		<article>" +
        "			<div class=\"jarviswidget\">" +
        "				<header>" +
        "					<h2 ng-model=\"color\"><i ng-class=\"widgetIconClass\"></i> {{ widgetTitle }}</h2>" +
        "				</header>" +
        "				<div>" +
        "					<div class=\"widget-body\">" +
        "                        <div ng-transclude></div>" +
        "					</div>" +
        "				</div>" +
        "			</div>" +
        "		</article>" +
        "	</div>" +
        "</section>" +
        "");
}]);


angular.module("templates/core/layout/widgetDataTable.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/widgetDataTable.html",
        "<section class=\"widget-data-table\">" +
        "	<div class=\"row\">" +
        "		<article>" +
        "			<div class=\"jarviswidget\">" +
        "				<header>" +
        "					<h2 ng-model=\"color\"><i ng-class=\"widgetIconClass\"></i> {{widgetTitle}}</h2>" +
        "				</header>" +
        "				<div>" +
        "					<div class=\"widget-body\">" +
        "                        <div ng-transclude></div>" +
        "					</div>" +
        "				</div>" +
        "			</div>" +
        "		</article>" +
        "	</div>" +
        "</section>" +
        "");
}]);